import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { CustomInput, Tooltip } from "reactstrap";
class CssMethod extends Component {
  render() {
    return (
      <div className="mt-3">
        <h5>Method</h5>

        <CustomInput
          type="radio"
          name="method"
          value="async"
          id="css-method-async"
          checked={this.props.value === "async"}
          className="mr-3"
          onChange={this.props.onChange}
          label="Async"
          required
          inline
        />

        <CustomInput
          type="radio"
          name="method"
          value="normal"
          id="css-method-normal"
          checked={this.props.value === "normal"}
          className="mr-1"
          onChange={this.props.onChange}
          label="Normal"
          required
          inline
        />
      </div>
    );
  }
}

export default CssMethod;
